// extracted by mini-css-extract-plugin
module.exports = {"switchy":"switchy--2QcCJ","switchInput":"switchInput--3KPyF","switchLabel":"switchLabel--_MwPM","switchLabelBefore":"switchLabelBefore--aI5XC"};